import { onMounted, onBeforeUnmount, nextTick } from '@vue/composition-api'
export const useKeyDown = (code, callBack) => {
  const handleToggleMenu = () => {
    if (typeof callBack === 'function') {
      callBack()
    }
  }

  const handle = (event) => {
    var e = event || window.event
    var keyCode = e.keyCode || e.which
    if (code === keyCode) {
      handleToggleMenu()
    }
  }
  const removeListener = () => {
    document.removeEventListener('keydown', handle, false)
  }
  const handleListener = () => {
    document.addEventListener('keydown', handle, false)
  }
  onMounted(() => {
    nextTick(() => {
      handleListener()
    })
  })

  onBeforeUnmount(() => {
    removeListener()
  })

  return {
    handleToggleMenu
  }
}
